import Fetch from 'whatwg-fetch';
import ENV from '../env';

let baseUrl = ENV.API_URL;

const service = {
    /**
     * HTTP GET 
     * 
     * @param string url
     * @param string authorization
     * 
     * @return json
     */
    get: function(url, authorization) {
        let headers = {
            'Accept': 'application/json',
        };

        if (authorization) headers.Authorization = 'Bearer ' + authorization;
        fetch.timeout = 1;
        return fetch(baseUrl + url, {
            headers: headers,
            'method': 'get'
        })
        .then(this.checkStatus)
        .catch(this.checkStatus);
    },

    post: function(url, body, authorization) {
        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        if (authorization) headers.Authorization = 'Bearer ' + authorization;

        return fetch(baseUrl + url, {
            headers: headers,
            method: 'post',
            body: JSON.stringify(body)
        })
        .then(this.checkStatus)
        .catch(this.checkStatus);
    },

    postWithFile: function(url, body, authorization) {
        let headers = {
            'Accept': 'application/json'
        };

        if (authorization) headers.Authorization = 'Bearer ' + authorization;

        return fetch(baseUrl + url, {
            headers: headers,
            method: 'post',
            body: body
        })
        .then(this.checkStatus)
        .catch(this.checkStatus);
    },

    put: function(url, body, authorization) {
        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        };

        if (authorization) headers.Authorization = 'Bearer ' + authorization;

        return fetch(baseUrl + url, {
            headers: headers,
            method: 'put',
            body: JSON.stringify(body)
        })
        .then(this.checkStatus)
        .catch(this.checkStatus);
    },

    delete: function(url, authorization) {
        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        };

        if (authorization) headers.Authorization = 'Bearer ' + authorization;

        return fetch(baseUrl + url, {
            headers: headers,
            method: 'delete'
        })
        .then(this.checkStatus)
        .catch(this.checkStatus);
    },

    /**
     * HTTP GET 
     * 
     * @param string url
     * @param string authorization
     * 
     * @return json
     */
    download: function(url) {
        window.open(baseUrl+url);
    },

    checkStatus: function(response) {
          if (response.status >= 200 && response.status < 300)
            return response.json();
         else if (response.status > 301)
             return response.json();
         else
            return {error:'unknown'};
    },
};

export default service;


/** WEBPACK FOOTER **
 ** ./app-react/services/fetch.js
 **/